export default __webpack_public_path__ + "static/piercing-arten-das-ohr-olga-ribler-b34bbadb95e1c22f057a3615f4377c07.jpg";